<template>
    <div>
        <Menu class="menu_header" mode="horizontal" theme="light" active-name="1">
            <div class="layout-logo"></div>
            <div class="layout-nav">
                <MenuItem name="1" style="font-size:16px;">
                    <router-link class="nav-link" to="/index">
                        首页
                    </router-link>
                </MenuItem>
                <MenuItem name="2" style="font-size:16px;">
                    <router-link class="nav-link" to="/product_center">
                        产品中心
                    </router-link>
                </MenuItem>
                <MenuItem name="3" style="font-size:16px;">
                    <router-link class="nav-link" to="/customer_case">
                        客户案例
                    </router-link>
                </MenuItem>
                <MenuItem name="4" style="font-size:16px;">
                    <router-link class="nav-link" to="/service_scope">
                        服务范围
                    </router-link>
                </MenuItem>
                <MenuItem name="5" style="font-size:16px;">
                    <router-link class="nav-link" to="/about_us">
                        关于我们
                    </router-link>
                </MenuItem>
            </div>
            <div class="layout-menu-icon" @click="menuNav = !menuNav">
                <img src="/static/image/list.png" alt="">
            </div>
        </Menu>
        <div class="full" v-show="menuNav" >
            <div class="menuNav">
                <Menu theme="light" active-name="1" mode="vertical" style="width: 100%;padding-top: 62px;">
                    <MenuItem name="1" >
                        <router-link class="nav-link" to="/index">
                            首页
                        </router-link>
                    </MenuItem>
                    <MenuItem name="2" >
                        <router-link class="nav-link" to="/product_center">
                            产品中心
                        </router-link>
                    </MenuItem>
                    <MenuItem name="3">
                        <router-link class="nav-link" to="/customer_case">
                            客户案例
                        </router-link>
                    </MenuItem>
                    <MenuItem name="4">
                        <router-link class="nav-link" to="/service_scope">
                            服务范围
                        </router-link>
                    </MenuItem>
                    <MenuItem name="5">
                        <router-link class="nav-link" to="/about_us">
                            关于我们
                        </router-link>
                    </MenuItem>
                </Menu>
            </div>
            <div class="spaceNav" @click="menuNav = !menuNav"></div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'header-nav',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      menuNav: false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.layout{
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    z-index:999;
    overflow: hidden;
}
.menu_header{
    width:100%;
    height:100%;
    display:flex;
    justify-content:center;
    align-items:center;
}
.layout-logo{
    width: 30%;
    max-width: 171px;
    height: 50px;
    background-image:url('/static/image/logo.png');
    background-size:100% 100%;
    border-radius: 3px;
    float: left;
    margin-right:150px;
}
.layout-menu-icon{
    display: none;
    cursor: pointer;
}
.layout-nav{
    max-width: 525px;
    width: 70%;
}
.layout-footer-center{
    text-align: center;
}

.nav-link {
    display: block;
    padding: 0 20px;
    color: #515a6e;
    text-decoration: 0;
    border-bottom: 2px solid transparent;
    transition: all .5s ease-in-out;
}

.nav-link:hover {
    color: #2d8cf0;
}

.nav-link:active {
    color: #0d50bf;
}
.full{
    position: fixed;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    z-index: 1000;
    flex-flow: nowrap;
    display: flex;
}
.menuNav {
    background-color: black;
    height: 100%;
    width: 30%;
    opacity: 0.9;
    min-width: 156px;
    float: left;
}
.spaceNav{
    background-color: rgba(14, 14, 14, 0.15);
    width: 70%;
    float: left;
    height: 100%;
    cursor: pointer;
}
.menuNav .ivu-menu-light {
     background: none;
 }
.menuNav .nav-link {
    color: white;
}
.menuNav .router-link-active {
    color: #1661e0;
    border-bottom: none;
}
.menuNav .ivu-menu-vertical .ivu-menu-item[data-v-6c465996], .ivu-menu-vertical .ivu-menu-submenu-title[data-v-6c465996] {
    padding: 0px 24px;
    position: relative;
    cursor: pointer;
    z-index: 1;
    font-size: 16px;
    border-bottom: 1px solid #4c494980;
     -webkit-transition: all .2s ease-in-out;
     transition: all .2s ease-in-out;
}
.menuNav .ivu-menu-vertical .ivu-menu-item, .ivu-menu-vertical .ivu-menu-submenu-title {
    padding: 0px 24px;
    position: relative;
    cursor: pointer;
    z-index: 1;
    transition: all .2s ease-in-out;
}
.menuNav .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
    color: #2d8cf0;
     background: none;
    z-index: 2;
}
.menuNav .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
    content: "";
    display: block;
    width: 2px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    background: none;
}
.menuNav .ivu-menu-vertical.ivu-menu-light:after {
    content: "";
    display: block;
    width: 1px;
    height: 100%;
    background: none;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
}
.ivu-menu-horizontal .ivu-menu-item,
.ivu-menu-horizontal .ivu-menu-submenu {
    padding: 0;
}

.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active {
    color: #1661e0;
    border: none;
}

.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
    color: #1661e0;
    border: none;
}

.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
    border: none;
}

.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:active
{
    color: #0d50bf;
    border: none;
}


.router-link-active {
    color: #1661e0;
    border-bottom: 3px solid #1661e0;
}

</style>
<style scoped>
    @media screen and (max-width: 854px) {
        .layout-menu-icon{
            display: block;
        }
        .layout-nav{
            display: none;
        }
        .menu_header{
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/header_nav.vue